export enum EQuickFilterKey {
  ID = 'sequencenumber',
  CREATED_BY = 'created by',
  CREATED = 'created',
  UPDATED = 'updated',
  EXCLUDED_TAGS = 'excluded tags',
  WORKSPACE_REF_ID = 'workspaceref.id',
}

export enum EQuickFilterTranslatedKey {
  ID = 'sequenceNumber',
  CREATED_BY = 'header.createdBy.id',
  CREATED = 'header.createdEpochMillis',
  UPDATED = 'header.updatedEpochMillis',
  EXCLUDED_TAGS = 'tags',
  WORKSPACE_REF_ID = 'workspaceRef.id',
}

export enum EReminderDTOKeys {
  TIMESTAMP_EPOCH_MILLIS = 'dateTime',
  POINT_ID = 'pointId',
  POINT_STATUS = 'pointStatus',
  DESCRIPTION = 'description',
  NAME = 'name',
  OWNER_ID = 'ownerId',
  POINT_PRIORITY = 'pointPriority',
  POINT_TITLE = 'pointTitle',
  DISMISSED = 'assignees.dismissed',
  SERIES_ID = 'seriesId',
  IS_SHARED = 'isShared',
}
